// @module StellarGrade.ST_NewsletterForm.NewsletterForm
define('StellarGrade.ST_Facets.Tooltip.View', ['Facets.FacetedNavigationItem.View', 'stellargrade_st_facets_tooltip.tpl', 'Backbone', 'jQuery'], function (
    FacetedNavigationItem,
    stellargrade_st_facets_tooltip_tpl,
    Backbone,
    $
) {
    'use strict';

    return {
        loadModule: function () {
            _.extend(FacetedNavigationItem.prototype, {
                // template : stellargrade_st_facets_tooltip_tpl,
                getContext: _.wrap(FacetedNavigationItem.prototype.getContext, function wrapper(fn) {
                    var context = fn.apply(this, _.toArray(arguments).slice(1));

                    $(document).ready(function () {
                        var tooltipData = {
                            custitem_stl_chassistype: {
                                name: 'Chassis Type',
                                choices: 'Fanless, Short Depth',
                                description: 'Choose from fanless designs for silent operation or short-depth chassis for space-constrained installations.',
                            },
                            custitem_chassis_size: {
                                name: 'Chassis Size',
                                choices: '1U (1.75" High), 2U (3.5" High), 3U (5.25" High), 4U (7" High)',
                                description: 'Select from compact 1U to spacious 4U rackmount PC & Server sizes, balancing performance and expandability.',
                            },
                            custitem_stl_processor: {
                                name: 'Processor',
                                choices: 'Intel 6th/7th Gen, 8/9th Gen, 10/11th Gen, 12/14th Gen, Celeron, Xeon',
                                description: 'Pick from Intel Celeron to Xeon processors, spanning 6th to 14th Gen, for your performance and efficiency needs.',
                            },
                            custitem_stl_powerinput: {
                                name: 'Power Input',
                                choices: '12v DC (9-18v), 24v DC (9-36v), AC (100-240v), 48v DC (36-75v), 250v, 300v, redundant power supplies',
                                description: 'Flexible power options include DC, AC, and redundant supplies for mission-critical applications.',
                            },
                            custitem_stl_casematerial: {
                                name: 'Case Material',
                                choices: 'Steel, ABS, Stainless Steel, Aluminum',
                                description: 'Choose from durable materials like steel, ABS, stainless steel, or aluminum for rugged reliability.',
                            },
                            custitem_stl_keysmaterial: {
                                name: 'Keys Material',
                                choices: 'Silicone Rubber, Stainless Steel',
                                description: 'Select silicone rubber for a tactile, sealed design or stainless steel for maximum durability in harsh environments.',
                            },
                            custitem_stl_builtinpointing: {
                                name: 'Built-in Pointing Device',
                                choices: 'Yes, No',
                                description: 'Opt for an integrated pointing device for all-in-one control or choose ‘No’ for external device compatibility.',
                            },
                            custitem_stl_pointingdevicetype: {
                                name: 'Pointing Device Type',
                                choices: 'Touchpad, FSR (Finger Sensing Resistor), Laser/Desktop, Trackball',
                                description: 'Available options include touchpad, FSR (finger sensing resistor), laser/desktop mouse, and trackball for precision control.',
                            },
                            custitem_stl_mounting: {
                                name: 'Mounting Support',
                                choices: 'VESA (Desktop), DIN Rail, Panel Mount, Open Frame, Rack Mount, Desktop',
                                description: 'Versatile mounting options include VESA (desktop), DIN Rail, Panel Mount, open frame, rack mount, and more for seamless integration.',
                            },
                            custitem_stl_displaysize: {
                                name: 'Display Size',
                                choices: '15", 15.6" (Wide), 17", 17.3" (Wide), 21.5" (Wide), 24"',
                                description: 'Available in sizes from 15” to 24”, including widescreen options, to match your space and visibility requirements.',
                            },
                            custitem_stl_touchoption: {
                                name: 'Touch Option',
                                choices: 'No Touch, Resistive Touch (RT), Multi-Touch (PCAP)',
                                description:
                                    'Choose no touch for standard displays, resistive touch (RT) for precision input, or multi-touch (PCAP) for modern interactive control.',
                            },
                            custitem_stl_kvmports: {
                                name: 'KVM Ports',
                                choices: 'Multiport-DVI, Multiport-VGA, Multiport-HDMI or DP, Multiport-CAT 6, Single Port',
                                description: 'Select the KVM port configuration that best suits your setup. Choose from multiport options like DVI, VGA, HDMI, DisplayPort, or CAT 6, or opt for a single-port solution for streamlined connectivity.',
                            },
                            custitem_stl_relatedproducttype: {
                                name: 'Related Product Type',
                                choices: 'Little PCs - Mini PCs, Rack Mount KVM Displays, Rack PCs and Servers',
                                description: 'Choose the right components to complement your Product Category for seamless integration and enhanced performance.',
                            },
                            custitem_stl_relatedproductmodel: {
                                name: 'Related Model',
                                choices: 'List of Accessories for a Product Model (Specific)',
                                description: 'View compatible accessories tailored for your selected product model to ensure seamless integration.',
                            },
                            custitem_soc_industries: {
                                name: 'Industries',
                                choices: 'Industrial, Defense, Government, Transportation/Marine, Utilities, Scientific/Research',
                                description: 'Explore products tailored to meet the demands of specialized and mission-critical environments.',
                            },
                            custitem11: {
                                name: 'Product',
                                choices: 'Computers, Custom Display, Standard Display, Rackmount Computers, Rackmount Keyboards or KVM, Keyboard and Pointing Device, Accessories',
                                description: 'Filter by specific product types to find the right computing, display, input, or accessory solutions for your needs.',
                            },
                        };

                        $('.facets-faceted-navigation-item-facet-group-title').each(function () {
                            var titleText = $(this).text().trim();

                            for (var key in tooltipData) {
                                if (tooltipData.hasOwnProperty(key)) {
                                    if (tooltipData[key].name === titleText) {
                                        var tooltipContent = `${tooltipData[key].description}`;

                                        var tooltip = $('<div class="tooltip-text"></div>').html(tooltipContent);

                                        $(this).append(tooltip);

                                        $(this).on('mouseenter', function () {
                                            $(this).find('.tooltip-text').css({
                                                visibility: 'visible',
                                                opacity: 1,
                                            });
                                        });

                                        $(this).on('mouseleave', function () {
                                            $(this).find('.tooltip-text').css({
                                                visibility: 'hidden',
                                                opacity: 0,
                                            });
                                        });

                                        break;
                                    }
                                }
                            }
                        });
                    });

                    return context;
                }),
            });
        },
    };
});
